/**
 * @generated SignedSource<<6134421535e0346a237f06337642086a>>
 * @relayHash e6b5b9361b4bf224ada55bcab8ce1d3a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6b5b9361b4bf224ada55bcab8ce1d3a

import { ConcreteRequest } from 'relay-runtime';
export type DoctorNetworkRole = "FAMILY_DOCTOR" | "GATEKEEPER" | "SPECIALIST";
export type Ch_createDoctorNetworkInput = {
  careProviderId: string;
  dateFrom?: any | null;
  dateTo?: any | null;
  patientId: string;
};
export type chCreateDoctorNetworkMutation$variables = {
  input: Ch_createDoctorNetworkInput;
};
export type chCreateDoctorNetworkMutation$data = {
  readonly createDoctorNetwork: {
    readonly doctorNetwork: {
      readonly createdAt: string;
      readonly patientId: string;
      readonly role: DoctorNetworkRole;
    } | null;
  };
};
export type chCreateDoctorNetworkMutation = {
  response: chCreateDoctorNetworkMutation$data;
  variables: chCreateDoctorNetworkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chCreateDoctorNetworkMutation",
    "selections": [
      {
        "alias": "createDoctorNetwork",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createDoctorNetworkPayload",
        "kind": "LinkedField",
        "name": "ch_createDoctorNetwork",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DoctorNetwork",
            "kind": "LinkedField",
            "name": "doctorNetwork",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chCreateDoctorNetworkMutation",
    "selections": [
      {
        "alias": "createDoctorNetwork",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createDoctorNetworkPayload",
        "kind": "LinkedField",
        "name": "ch_createDoctorNetwork",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DoctorNetwork",
            "kind": "LinkedField",
            "name": "doctorNetwork",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e6b5b9361b4bf224ada55bcab8ce1d3a",
    "metadata": {},
    "name": "chCreateDoctorNetworkMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ce660ce670aebd33316e57a4cf33a29f";

export default node;
